export const useIncomingShareIntent = () => {
  /* Do nothing */
}
